import {
  InteractiveContainer,
  InteractiveContainerProps,
} from "@jugl-web/ui-components/cross-platform/InteractiveContainer";
import { cx } from "@jugl-web/utils";
import { FC, forwardRef, ReactNode, SVGProps } from "react";
import { ReactComponent as ChevronRightIcon } from "../../assets/chevron-right.svg";

interface TriggerButtonBaseProps
  extends Omit<InteractiveContainerProps, "children"> {
  label: string;
  value: string;
  Icon: FC<SVGProps<SVGSVGElement>>;
  isFocused?: boolean;
  customEndSlot?: ReactNode;
}
export const TriggerButtonBase = forwardRef<
  HTMLDivElement,
  TriggerButtonBaseProps
>(
  (
    {
      label,
      value,
      Icon,
      isFocused,
      isDisabled,
      customEndSlot,
      className,
      ...props
    },
    ref
  ) => (
    <InteractiveContainer
      ref={ref}
      className={cx(
        "flex h-10 items-center justify-between rounded-lg border border-solid border-transparent bg-grey-100 px-2 transition-colors outline-none focus-visible:border-primary",
        isFocused && "border-primary",
        !isDisabled && "hover:bg-grey-200",
        className
      )}
      isDisabled={isDisabled}
      {...props}
    >
      <div
        className={cx(
          "flex items-center overflow-hidden",
          isDisabled ? "text-dark-300" : "text-dark-800"
        )}
      >
        <Icon
          className={cx(
            "shrink-0",
            isDisabled
              ? "text-grey-background"
              : "text-messages-chat-bubble-sender"
          )}
        />
        <span className="mr-2 ml-2.5 text-sm font-medium">{label}:</span>
        <span className="truncate text-sm font-normal">{value}</span>
      </div>
      {customEndSlot || (
        <ChevronRightIcon
          className={cx(
            "shrink-0",
            isDisabled ? "text-[#E0E0E0]" : "text-grey-700"
          )}
        />
      )}
    </InteractiveContainer>
  )
);
